import {
	Avatar,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	makeStyles,
	Slide,
	TextField,
} from "@material-ui/core";
import { lightGreen } from "@material-ui/core/colors";
import React, { useContext, useEffect, useState } from "react";
import authContext from "../../../context/Auth/authContext";

const useStyles = makeStyles((theme) => ({
	fotoProfile: {
		color: theme.palette.getContrastText(lightGreen[500]),
		backgroundColor: lightGreen[500],
		width: "100px",
		height: "100px",
		fontSize: "50px",
		marginTop: "20px",
		outline: "none",
		[theme.breakpoints.down("xs")]: {
			width: "50px",
			height: "50px",
			fontSize: "25px",
		},
	},
	formProfile: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		"& > *": {
			margin: theme.spacing(1),
			width: 400,
			[theme.breakpoints.down("xs")]: {
				width: 200,
			},
		},
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

const Profile = ({ open, handleClose }) => {
	const classes = useStyles();
	const [state, setState] = useState({
		nama_user: "",
		username: "",
		visiting: "",
		phone: "",
		email: "",
	});
	const AuthContext = useContext(authContext);
	const { user } = AuthContext;

	useEffect(() => {
		if (user) {
			setState({
				nama_user: user.nama_user,
				username: user.username,
				visiting: user.visiting,
				phone: user.phone,
				email: user.email,
			});
		}
	}, [user]);

	return (
		<Dialog
			open={open}
			TransitionComponent={Transition}
			keepMounted
			onClose={handleClose}
			aria-labelledby="alert-dialog-slide-title"
			aria-describedby="alert-dialog-slide-description"
			maxWidth="md"
		>
			<DialogContent>
				<Grid
					container
					direction="column"
					justifyContent="center"
					alignItems="center"
				>
					<Avatar alt="Dev Sharp" className={classes.fotoProfile}>
						<img
							alt="user"
							src={"assets/images/user.png"}
							height="100"
							width="100"
						/>
					</Avatar>
					<DialogTitle> {state.nama_user}</DialogTitle>
					<form className={classes.formProfile} noValidate autoComplete="off">
						<TextField
							label="username"
							value={state.username}
							size="small"
							disabled
						/>
						<TextField
							label="username"
							value={state.email}
							size="small"
							type="email"
							disabled
						/>
						<TextField
							label="Visiting"
							value={state.visiting}
							size="small"
							disabled
						/>
						<TextField
							label="Phone Number"
							value={state.phone}
							size="small"
							disabled
						/>
					</form>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default Profile;
